// extracted by mini-css-extract-plugin
export default {"systemDetailsOverview":"SystemDetailsOverview_systemDetailsOverview__jXG-F","block":"SystemDetailsOverview_block__IyotI","blockDetails":"SystemDetailsOverview_blockDetails__xhpWd"};